/**
 * Prev/next arrows for the Empire product gallery.
 *
 * Uses only core Swiper API (slidePrev/slideNext/isBeginning/isEnd), so it does
 * not matter whether the Navigation module is included in vendor.swiper.js.
 * Thumbnails stay in sync automatically because they follow the main swiper.
 *
 * Load once, e.g. before </body> in layout/theme.liquid:
 *   <script src="{{ 'product.gallery-arrows.js' | asset_url }}" defer></script>
 */
(function () {
  if (window.__galleryArrowsLoaded) return;
  window.__galleryArrowsLoaded = true;

  var ICON = {
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 4 7 12l8 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 4l8 8-8 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  var LABEL = { prev: 'Previous image', next: 'Next image' };

  // Poll for up to 6s: the gallery is a lazily hydrated custom element, so the
  // Swiper instance does not exist at DOMContentLoaded.
  var POLL_MS = 100;
  var POLL_MAX = 60;

  var wired = new WeakSet();

  function makeButton(dir) {
    var button = document.createElement('button');
    button.type = 'button';
    // swiper-no-swiping stops a press on the button from starting a drag.
    button.className = 'gallery-arrow gallery-arrow--' + dir + ' swiper-no-swiping';
    button.setAttribute('aria-label', LABEL[dir]);
    button.innerHTML = ICON[dir];
    return button;
  }

  function wire(viewer) {
    if (wired.has(viewer)) return true;

    var swiper = viewer.swiper;
    if (!swiper || typeof swiper.slideNext !== 'function') return false;

    wired.add(viewer);

    var prev = makeButton('prev');
    var next = makeButton('next');

    function handle(method) {
      return function (event) {
        // The zoom trigger sits on .swiper-slide__inner. These buttons are
        // siblings of .swiper-wrapper, so they should not reach it, but stop
        // propagation anyway in case the listener is delegated from the root.
        event.preventDefault();
        event.stopPropagation();
        swiper[method]();
      };
    }

    prev.addEventListener('click', handle('slidePrev'));
    next.addEventListener('click', handle('slideNext'));

    [prev, next].forEach(function (button) {
      button.addEventListener('mousedown', function (e) { e.stopPropagation(); });
      button.addEventListener('touchstart', function (e) { e.stopPropagation(); }, { passive: true });
    });

    function sync() {
      var looping = swiper.params && swiper.params.loop;
      prev.disabled = !looping && swiper.isBeginning;
      next.disabled = !looping && swiper.isEnd;
    }

    swiper.on('slideChange', sync);
    swiper.on('resize', sync);
    swiper.on('update', sync);
    sync();

    viewer.appendChild(prev);
    viewer.appendChild(next);

    return true;
  }

  function init(gallery) {
    var viewer = gallery.querySelector('[data-swiper-viewer]');
    if (!viewer) return;
    if (gallery.querySelectorAll('.swiper-slide').length < 2) return;

    var tries = 0;
    (function attempt() {
      if (wire(viewer)) return;
      if (++tries >= POLL_MAX) return;
      setTimeout(attempt, POLL_MS);
    })();
  }

  function scan(root) {
    (root || document).querySelectorAll('product-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Catch galleries injected later, e.g. quick shop modals.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('product-gallery')) init(node);
        else if (node.querySelectorAll) scan(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
